// extracted by mini-css-extract-plugin
module.exports = {"navbar":"panelNavbar_navbar__2Zl4A","toggle":"panelNavbar_toggle__3PAjN","logo":"panelNavbar_logo__gYSq7","dropdown-menu":"panelNavbar_dropdown-menu__3XMoQ"};